import { render, staticRenderFns } from "./LoginWeChat.vue?vue&type=template&id=51808d7e&scoped=true"
import script from "./LoginWeChat.vue?vue&type=script&lang=js"
export * from "./LoginWeChat.vue?vue&type=script&lang=js"
import style0 from "./LoginWeChat.vue?vue&type=style&index=0&id=51808d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51808d7e",
  null
  
)

export default component.exports